import React, { useEffect, useState } from "react"
import bootSnapEngage from 'shared/helpers/snap-engage'
import { INCROWD_BRAND, INCROWD_RESPONDER_TYPE_ID, OS_HCP_BRAND, OS_RESPONDER_TYPE_ID, setCssVariables } from "../helper/registration"
import GetStartedComponent from "./GetStartedComponent"
import HeaderComponent from "./HeaderComponent"
import RegistrationFooterComponent from "./RegistrationFooterComponent"
import FooterComponent from "./FooterComponent"
import { getMarkets } from "../apicalls/api-calls"
import WelcomeComponent from "./WelcomeComponent"
import ReCaptcha from "./ReCaptcha"
import { enableCaptcha } from "../helper/captcha"
import i18next from "i18next"
import { getTimeZones } from "../../shared/helpers/timezone"
import {determineValidInitialIsoCode} from "../../shared/helpers/localization"
import {getLanguages} from "../../shared/helpers/api-calls"
import "register/less/registration.less"
import {yotiServiceRequest} from 'shared/helpers/app'

const RegistrationComponent = () => {
    const [markets, setMarkets] = useState([])
    const [languages, setLanguages] = useState([])
    const [languagesIds, setLanguagesIds] = useState([])
    const [timeZones, setTimeZones] = useState([])
    const [email, setEmail] = useState(new URLSearchParams(window.location.search).get('email'))
    const [accessToken, setAccessToken] = useState("")
    const [userId, setUserId] = useState("")
    const [marketId, setMarketId] = useState("")
    const [languageId, setLanguageId] = useState("")
    const [showWelcomePage, setShowWelcomePage] = useState(false)
    const [showValidationPage, setShowValidationPage] = useState(false)
    const [showJoinIncrowd, setShowJoinIncrowd] = useState(false)
    const [showJoinOS, setShowJoinOS] = useState(false)
    const [responderTypeId, setResponderTypeId] = useState(INCROWD_RESPONDER_TYPE_ID)
    const [brandId, setBrandId] = useState(INCROWD_BRAND)
    const [referredId, setReferredId] = useState("")
    const [referrerDescription, setReferrerDescription] = useState("")
    const [src, setSrc] = useState("")
    const [url, setUrl] = useState("")
    const [recruitmentSource, setRecruitmentSource] = useState("")
    const [showYotiMessage, setShowYotiMessage] = useState(false)
    const search = window.location.search
    const isShgRegistration =
        (window.location.host.includes('localhost') && new URLSearchParams(search).get('isSHG') == 'true')
        || (window.location.host === 'opinionsite_web-qa.incrowdanswers.com')
        || (window.location.host === 'www.opinionsite_web-qa.incrowdanswers.com')
        || (window.location.host === 'opinionsite.incrowdanswers.com')
        || (window.location.host === 'www.opinionsite.incrowdanswers.com')
        || (window.location.host === 'opinionsite_core-qa.incrowdanswers.com')
        || (window.location.host === 'www.opinionsite_core-qa.incrowdanswers.com')
        || (window.location.host === 'opinionsite_data-qa.incrowdanswers.com')
        || (window.location.host === 'www.opinionsite_data-qa.incrowdanswers.com')
        || (window.location.host === 'opinionsite_qual-qa.incrowdanswers.com')
        || (window.location.host === 'www.opinionsite_qual-qa.incrowdanswers.com')
        || (window.location.host === 'opinionsite_shg-panel-dev-staging.incrowdanswers.com')
        || (window.location.host === 'www.opinionsite_shg-panel-dev-staging.incrowdanswers.com')
        || (window.location.host === 'opinionsite_mercury-qa.incrowdanswers.com')
        || (window.location.host === 'www.opinionsite_mercury-qa.incrowdanswers.com')
        || (window.location.host.includes('opinionsiteanswers.com'))
    const GlobalStyles = setCssVariables(isShgRegistration)

    useEffect(() => {
        getRegLanguages()
        getRegTimeZones()
        bootSnapEngage(isShgRegistration)
        initializeIds()
        displayYotiMessage()
    }, [])
    const displayYotiMessage = async () =>{
        let result = await yotiServiceRequest(`get-user-ip-info`,'GET')
        setShowYotiMessage(result.result ? result.result : false)
    }
    const initializeIds = () => {
        const referrer = new URLSearchParams(search).get('referredId')
        if (isShgRegistration) {
            const source = new URLSearchParams(search).get('src')
            setResponderTypeId(OS_RESPONDER_TYPE_ID)
            setBrandId(OS_HCP_BRAND)
            setReferredId(referrer)
            setReferrerDescription(new URLSearchParams(search).get('referredDescription'))
            setSrc(source)
            setUrl(window.location.href)
            require("register/less/os-registration.less")
            setRecruitmentSource(referrer)
        } else {
            setResponderTypeId(INCROWD_RESPONDER_TYPE_ID)
            setBrandId(INCROWD_BRAND)
            setReferredId(referrer)
            setReferrerDescription(new URLSearchParams(search).get('referredDescription'))
            require("register/less/incrowd-registration.less")
            setRecruitmentSource(referrer)
        }
    }

    const setMarketsResult = (marketsResult) => {
        marketsResult.map(market => {
            market.label = market.name
            market.value = market.id
            return market
        })
        setMarkets(marketsResult)
    }

    const showValidation = () => {
        setShowValidationPage(true)
    }

    const setLanguagesResult = (languagesResult, languagesIdsResult) => {
        setLanguages(languagesResult)
        setLanguagesIds(languagesIdsResult)
    }

    const getRegMarkets = (langIsoCode) => {
        getMarkets(langIsoCode, (marketsValue) => setMarketsResult(marketsValue))
    }

    const getRegLanguages = () => {
        getLanguages((languagesValue, languagesIdsValues) => setLanguagesResult(languagesValue, languagesIdsValues))
    }

    const getRegTimeZones = () => {
      setTimeZones(getTimeZones())
    }

    const setEmailValue = (emailValue) => {
        setEmail(emailValue)
    }

    const setRegistrationData = (regData) => {
        if (regData) {
            if (regData.externalEmail && responderTypeId == OS_RESPONDER_TYPE_ID) {
                setEmail(regData.externalEmail)
            } else if (regData.email) {
                setEmail(regData.email)
            }
            if (regData.userId) {
                setUserId(regData.userId)
            }
            if (regData.accessToken) {
                setAccessToken(regData.accessToken)
            }
            if (regData.marketId) {
                setMarketId(regData.marketId)
            }
            if (regData.offerIncrowdRegistration) {
                setShowJoinIncrowd(true)
            }
            if (regData.offerOSRegistration) {
                setShowJoinOS(true)
            }
            setShowWelcomePage(true)
        }
    }

    useEffect(() => {
        setRecruitmentSource(referredId)
    }, [referredId])

    useEffect(() => {
        if (languages && languages.length > 0) {
            let isoCode = i18next.language
            if (isoCode) {
                isoCode = determineValidInitialIsoCode(isoCode.toLowerCase().replace("-", "_"))
                let initialIsoCode = languages.find(x => x.value.startsWith(isoCode))
                if (initialIsoCode) {
                    i18next.changeLanguage(isoCode)
                    setLanguageId(initialIsoCode.languageId)
                } else {
                    isoCode = "en_us"
                    i18next.changeLanguage(isoCode)
                    setLanguageId(languages.find(x => x.value.startsWith(isoCode)).languageId)
                }
            }
            getRegMarkets(isoCode)
        }
    }, [languages])

    useEffect(() => {
        if (showValidationPage) {
            window.location.href = `/validation?userId=${userId}&accessToken=${accessToken}#/yoti-loading`
        }
    }, [showValidationPage])

    return (
        <div style={{ display: "block", height: "100%" }}>
            <GlobalStyles />
            <HeaderComponent
                isShgRegistration={isShgRegistration}
                languageId={languageId}
            />
            <div className="body-container">
                {!showWelcomePage && (
                    <div className="get-started-wrapper">
                        <GetStartedComponent
                            setRegistrationData={setRegistrationData}
                            referredId={referredId}
                            setEmail={setEmailValue}
                            referrerDescription={referrerDescription}
                            src={src}
                            url={url}
                            email={email}
                            responderTypeId={responderTypeId}
                            languageId={languageId}
                            isShgRegistration={isShgRegistration}
                            showYotiMessage = {showYotiMessage}
                            />
                        <div className="get-started-separator" />
                        <RegistrationFooterComponent
                            isShgRegistration={isShgRegistration}
                            markets={markets}
                        />
                    </div>
                )}
                {showWelcomePage && !showValidationPage &&
                    <WelcomeComponent
                        languages={languagesIds}
                        timeZones={timeZones}
                        showValidation={showValidation}
                        setEmail={setEmail}
                        email={email} userId={userId} accessToken={accessToken}
                        marketId={marketId}
                        languageId={languageId}
                        showJoinIncrowd={showJoinIncrowd}
                        showJoinOS={showJoinOS}
                        brandId={brandId}
                        responderTypeId={responderTypeId}
                        isShgRegistration={isShgRegistration}
                        recruitmentSource={recruitmentSource}
                        updateLanguage={(language) => setLanguageId(language)} />
                }
            </div>
            {enableCaptcha && <ReCaptcha />}
            <FooterComponent
                isShgRegistration={isShgRegistration}
                languageId={languageId} />
        </div>
    )
}
export default RegistrationComponent